import React from 'react';

export default class Page7 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <table className="ilead_v_sport tablesrink " border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th colSpan="2" className="green_curve green_curve1"
                                                        align="left" valign="top">Section 5: Need for Variety
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">1. </span> Excited
                                                            by new ideas</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="ExcitedByNewIdeas"
                                                               id="ExcitedByNewIdeas"
                                                               onChange={this.props.handleChangePageData('variety')}
                                                               checked={!!pageData?.variety?.ExcitedByNewIdeas}/>
                                                        <label className="cursor-pointer" htmlFor="ExcitedByNewIdeas">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">2. </span> Starts
                                                            new projects but doesn't finish them</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="StartsNewProjectsButDoesntFinishThem"
                                                               id="StartsNewProjectsButDoesntFinishThem"
                                                               onChange={this.props.handleChangePageData('variety')}
                                                               checked={!!pageData?.variety?.StartsNewProjectsButDoesntFinishThem}/>
                                                        <label className="cursor-pointer" htmlFor="StartsNewProjectsButDoesntFinishThem">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">3. </span> Easily
                                                            bored</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="EasilyBored"
                                                               id="EasilyBored"
                                                               onChange={this.props.handleChangePageData('variety')}
                                                               checked={!!pageData?.variety?.EasilyBored}/>
                                                        <label className="cursor-pointer" htmlFor="EasilyBored">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">4. </span> Follows
                                                            own agenda - expedient</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="FollowsOwnAgendaExpedient"
                                                               id="FollowsOwnAgendaExpedient"
                                                               onChange={this.props.handleChangePageData('variety')}
                                                               checked={!!pageData?.variety?.FollowsOwnAgendaExpedient}/>
                                                        <label className="cursor-pointer" htmlFor="FollowsOwnAgendaExpedient">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">5. </span> Innovative
                                                            approach</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="InnovativeApproach"
                                                               id="InnovativeApproach"
                                                               onChange={this.props.handleChangePageData('variety')}
                                                               checked={!!pageData?.variety?.InnovativeApproach}/>
                                                        <label className="cursor-pointer" htmlFor="InnovativeApproach">&nbsp;</label>

                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <table className="ilead_v_sport tablesrink " border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th colSpan="2" className="green_curve green_curve1"
                                                        align="left" valign="top">Section 6: Need for Structure
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">1. </span> Organised
                                                        </p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="Organised"
                                                               id="Organised"
                                                               onChange={this.props.handleChangePageData('structure')}
                                                               checked={!!pageData?.structure?.Organised}/>
                                                        <label className="cursor-pointer" htmlFor="Organised">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">2. </span> Reliable
                                                        </p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="Reliable"
                                                               id="Reliable"
                                                               onChange={this.props.handleChangePageData('structure')}
                                                               checked={!!pageData?.structure?.Reliable}/>
                                                        <label className="cursor-pointer" htmlFor="Reliable">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">3. </span> Dislikes
                                                            ambiguity</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="DislikesAmbiguity"
                                                               id="DislikesAmbiguity"
                                                               onChange={this.props.handleChangePageData('structure')}
                                                               checked={!!pageData?.structure?.DislikesAmbiguity}/>
                                                        <label className="cursor-pointer" htmlFor="DislikesAmbiguity">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">4. </span> Plans
                                                            work well</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="PlansWorkWell"
                                                               id="PlansWorkWell"
                                                               onChange={this.props.handleChangePageData('structure')}
                                                               checked={!!pageData?.structure?.PlansWorkWell}/>
                                                        <label className="cursor-pointer" htmlFor="PlansWorkWell">&nbsp;</label>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">5. </span> Communicates
                                                            frequently, clearly and consistently</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="CommunicatesFrequentlyClearlyAndConsistently"
                                                               id="CommunicatesFrequentlyClearlyAndConsistently"
                                                               onChange={this.props.handleChangePageData('structure')}
                                                               checked={!!pageData?.structure?.CommunicatesFrequentlyClearlyAndConsistently}/>
                                                        <label className="cursor-pointer" htmlFor="CommunicatesFrequentlyClearlyAndConsistently">&nbsp;</label>

                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <table className="ilead_v_sport tablesrink " border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th colSpan="2" className="green_curve green_curve1"
                                                        align="left" valign="top">Section 7: Need to Care
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">1. </span> Considerate
                                                            to others' situation</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="ConsiderateToOthersSituation"
                                                               id="ConsiderateToOthersSituation"
                                                               onChange={this.props.handleChangePageData('care')}
                                                               checked={!!pageData?.care?.ConsiderateToOthersSituation}/>
                                                        <label className="cursor-pointer" htmlFor="ConsiderateToOthersSituation">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">2. </span> Genuine
                                                            concern for colleagues' welfare</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="GenuineConcernForColleaguesWelfare"
                                                               id="GenuineConcernForColleaguesWelfare"
                                                               onChange={this.props.handleChangePageData('care')}
                                                               checked={!!pageData?.care?.GenuineConcernForColleaguesWelfare}/>
                                                        <label className="cursor-pointer" htmlFor="GenuineConcernForColleaguesWelfare">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">3. </span> Empathetic
                                                        </p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="Empathetic"
                                                               id="Empathetic"
                                                               onChange={this.props.handleChangePageData('care')}
                                                               checked={!!pageData?.care?.Empathetic}/>
                                                        <label className="cursor-pointer" htmlFor="Empathetic">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">4. </span> Supportive
                                                        </p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="Supportive"
                                                               id="Supportive"
                                                               onChange={this.props.handleChangePageData('care')}
                                                               checked={!!pageData?.care?.Supportive}/>
                                                        <label className="cursor-pointer" htmlFor="Supportive">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">5. </span> Tolerant
                                                            of others</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="TolerantOfOthers"
                                                               id="TolerantOfOthers"
                                                               onChange={this.props.handleChangePageData('care')}
                                                               checked={!!pageData?.care?.TolerantOfOthers}/>
                                                        <label className="cursor-pointer" htmlFor="TolerantOfOthers">&nbsp;</label>

                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <table className="ilead_v_sport tablesrink " border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th colSpan="2" className="green_curve green_curve1"
                                                        align="left" valign="top">Section 8: Need for Control
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">1. </span> Takes
                                                            control of team activities</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="TakesControlOfTeamActivities"
                                                               id="TakesControlOfTeamActivities"
                                                               onChange={this.props.handleChangePageData('control')}
                                                               checked={!!pageData?.control?.TakesControlOfTeamActivities}/>
                                                        <label className="cursor-pointer" htmlFor="TakesControlOfTeamActivities">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">2. </span> Sees
                                                            others' support as interference</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="SeesOthersSupportAsInterference"
                                                               id="SeesOthersSupportAsInterference"
                                                               onChange={this.props.handleChangePageData('control')}
                                                               checked={!!pageData?.control?.SeesOthersSupportAsInterference}/>
                                                        <label className="cursor-pointer" htmlFor="SeesOthersSupportAsInterference">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">3. </span> Does
                                                            things in own way, regardless of feedback</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="DoesThingsInOwnWayRegardlessOfFeedback"
                                                               id="DoesThingsInOwnWayRegardlessOfFeedback"
                                                               onChange={this.props.handleChangePageData('control')}
                                                               checked={!!pageData?.control?.DoesThingsInOwnWayRegardlessOfFeedback}/>
                                                        <label className="cursor-pointer" htmlFor="DoesThingsInOwnWayRegardlessOfFeedback">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">4. </span> Becomes
                                                            tense in uncertain situations</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="BecomesTenseInUncertainSituations"
                                                               id="BecomesTenseInUncertainSituations"
                                                               onChange={this.props.handleChangePageData('control')}
                                                               checked={!!pageData?.control?.BecomesTenseInUncertainSituations}/>
                                                        <label className="cursor-pointer" htmlFor="BecomesTenseInUncertainSituations">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">5. </span> Finds
                                                            it difficult to delegate to others</p></div>
                                                    </td>
                                                    <td className="darkgreen"
                                                        style={{paddingLeft: '10px !important'}} align="center"
                                                        valign="top" width="6%">

                                                        <input type="checkbox" name="FindsItDifficultToDelegateToOthers"
                                                               id="FindsItDifficultToDelegateToOthers"
                                                               onChange={this.props.handleChangePageData('control')}
                                                               checked={!!pageData?.control?.FindsItDifficultToDelegateToOthers}/>
                                                        <label className="cursor-pointer" htmlFor="FindsItDifficultToDelegateToOthers">&nbsp;</label>

                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page6')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div onClick={this.props.savePageData('Page8')}
                                                                          className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}